import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { Component, HostBinding, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { FieldConfig } from "../../field.interface";
import { LimpiarService } from "./service/limpiar.service";
@Component({
  selector: "app-button",
  template: `
    <div class="row" *ngIf="!hidden()">
          <div class="col-12 demo-full-width margin-top" [formGroup]="group" >
            <button class="mx-1" type="button" mat-raised-button color="secondary" (click)="onClick()">{{field.label}}</button>
          </div>
      </div>
`,
  styles: []
})
export class ButtonComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  @HostBinding('class') class = '';
  @Input() callback: (args: any) => void;
  constructor(
    private router: Router,
    private limpiarService: LimpiarService) {
  }
  ngOnInit() {
    this.class = this.field.claseGrillaBootstrap;
  }

  hidden() {
    return this.field.visible === false;
  }

  onClick() {
    if (this.field.urlRedirect) {
      this.router.navigateByUrl(this.field.urlRedirect);
    }
    else if (this.field.limpiar === true) {
      this.limpiarService.limpiarForm.next(true);
    } else {
      this.field.callback(null);
    }
  }
}
